import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Input
} from '@angular/core';

@Component({
  selector: 'phx-content-card',
  styleUrls: ['./phx-content-card.scss'],
  templateUrl: './phx-content-card.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-content-card',
    '[class.phx-hide-header]': `phxHideHeader`,
    '[class.phx-content-card-body-padding-none]': `phxNoBodyPadding`,
  },
})
export class PhxContentCardComponent implements AfterViewInit {
  @Input() phxNoBodyPadding: boolean = false;
  @ViewChild('title', { read: ElementRef, static: false }) titleContent: ElementRef;
  @ViewChild('actions', { read: ElementRef, static: false }) actionsContent: ElementRef;

  public phxHideHeader: boolean = false;

  constructor(private _cdr: ChangeDetectorRef) {
  }

  public ngAfterViewInit() {
    this.phxHideHeader = this.titleContent?.nativeElement?.innerHTML.length === 0 && this.actionsContent?.nativeElement?.innerHTML.length === 0;
    this._cdr.markForCheck();
  }



}

